export const endpoints = {
  GET_COMMUNICATION_BY_ORGANIZATION_ID: '/communications',
};
